import Group from "../composition/Group"
import Light from "../composition/Light"

const ElectricalAccessories: ElectricalAccesories[] = [
  {
    "models": ["0270"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 3,
            "Z": "A40480/0Z",
            "A": "A40380/0A",
            "B": "A00180/0A"
          },
          {
            "number_support": 5,
            "0": "A00880/0B"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["0345"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 3,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 4,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 5,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A020-80/01",
            "2": "A028-80/02"
          },
          {
            "number_support": 3,
            "1": "A020-80/01",
            "2": "A032-80/02",
            "7": "A030-80/07"
          },
          {
            "number_support": 4,
            "2": "A032-80/02",
            "7": "A031-80/07"
          },
          {
            "number_support": 5,
            "7": "A031-80/07"
          },
          {
            "number_support": 6,
            "A": "A017-80/0A"
          },
          {
            "number_support": 7,
            "A": "A017-80/0A"
          },
          {
            "number_support": 8,
            "A": "A017-80/0A"
          }
        ]
      }
    ]
  },
  {
    "models": ["0361"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 3,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 4,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 5,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A020-80/01",
            "2": "A028-80/02"
          },
          {
            "number_support": 3,
            "1": "A020-80/01",
            "2": "A032-80/02",
            "7": "A030-80/07"
          },
          {
            "number_support": 4,
            "2": "A032-80/02",
            "7": "A031-80/07"
          },
          {
            "number_support": 5,
            "7": "A031-80/07"
          },
          {
            "number_support": 6,
            "A": "A017-80/0A"
          },
          {
            "number_support": 7,
            "A": "A017-80/0A"
          },
          {
            "number_support": 8,
            "A": "A017-80/0A"
          }
        ]
      }
    ]
  },
  {
    "models": ["0820"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A04380/0Z",
            "A": "A04380/0Z"
          },
          {
            "number_support": 3,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          },
          {
            "number_support": 4,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          },
          {
            "number_support": 5,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          },
          {
            "number_support": 6,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          },
          {
            "number_support": 7,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          },
          {
            "number_support": 8,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          },
          {
            "number_support": 9,
            "Z": "A04380/0Z",
            "A": "A00380/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A023-80/0B"
          },
          {
            "number_support": 3,
            "1": "A020-80/01",
            "7": "A035-80/07"
          },
          {
            "number_support": 4,
            "1": "A020-80/01",
            "7": "A035-80/07"
          },
          {
            "number_support": 5,
            "1": "A020-80/01",
            "7": "A035-80/07"
          },
          {
            "number_support": 6,
            "A": "A018-80/0A",
            "7": "A036-80/07"
          },
          {
            "number_support": 7,
            "A": "A018-80/0A",
            "7": "A036-80/07"
          },
          {
            "number_support": 8,
            "A": "A018-80/0A",
            "7": "A036-80/07"
          },
          {
            "number_support": 9,
            "A": "A018-80/0A",
            "7": "A036-80/07"
          }
        ]
      }
    ]
  },

  {
    "models": ["0920"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 3,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 4,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 5,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 6,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 7,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 8,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          },
          {
            "number_support": 9,
            "1": "A00580/01",
            "Z": "A04580/0Z",
            "B": "A00880/0B"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A020-80/01",
            "2": "A023-80/0B"
          },
          {
            "number_support": 3,
            "1": "A020-80/01",
            "2": "A028-80/02",
            "7": "A030-80/07"
          },
          {
            "number_support": 4,
            "1": "A020-80/01",
            "2": "A032-80/02",
            "7": "A030-80/07"
          },
          {
            "number_support": 5,
            "1": "A020-80/01",
            "2": "A032-80/02",
            "7": "A031-80/07"
          },
          {
            "number_support": 6,
            "2": "A032-80/02",
            "A": "A017-80/0A",
            "7": "A031-80/07"
          },
          {
            "number_support": 7,
            "2": "A034-80/02",
            "A": "A017-80/0A",
            "7": "A031-80/07"
          },
          {
            "number_support": 8,
            "2": "A034-80/02",
            "A": "A017-80/0A",
            "7": "A031-80/07"
          },
          {
            "number_support": 9,
            "2": "A034-80/02",
            "A": "A017-80/0A"
          }
        ]
      }
    ]
  },
  {
    "models": ["2350"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 3,
            "1": "A01580/01",
            "3": "A01280/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 4,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04780/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A033-80/01",
            "3": "A024-80/03"
          },
          {
            "number_support": 3,
            "1": "A033-80/01"
          },
          {
            "number_support": 4,
            "1": "A026-80/01"
          }
        ]
      }
    ]
  },
  {
    "models": ["2351"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 3,
            "1": "A01580/01",
            "3": "A01280/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 4,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04780/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A033-80/01",
            "3": "A024-80/03"
          },
          {
            "number_support": 3,
            "1": "A033-80/01"
          },
          {
            "number_support": 4,
            "1": "A026-80/01"
          }
        ]
      }
    ]
  },
  {
    "models": ["2355"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 3,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 4,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 5,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04780/0Z"
          },
          {
            "number_support": 6,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04780/0Z"
          },
          {
            "number_support": 7,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          },
          {
            "number_support": 8,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          },
          {
            "number_support": 9,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A033-80/01",
            "3": "A025-80/03"
          },
          {
            "number_support": 3,
            "1": "A033-80/01",
            "3": "A024-80/03"
          },
          {
            "number_support": 4,
            "1": "A026-80/01"
          }
        ]
      }
    ]
  },
  {
    "models": ["5520"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 3,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 4,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 5,
            "1": "A01580/01",
            "3": "A01280/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 6,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04780/0Z"
          },
          {
            "number_support": 7,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          },
          {
            "number_support": 8,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          },
          {
            "number_support": 9,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A033-80/01",
            "3": "A025-80/03"
          },
          {
            "number_support": 3,
            "1": "A033-80/01",
            "3": "A024-80/03"
          },
          {
            "number_support": 4,
            "1": "A033-80/01"
          }
        ]
      }
    ]
  },
  {
    "models": ["5525"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 3,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 4,
            "1": "A01580/01",
            "3": "A01080/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 5,
            "1": "A01580/01",
            "3": "A01280/03",
            "Z": "A04980/0Z"
          },
          {
            "number_support": 6,
            "1": "A01380/01",
            "3": "A01280/03",
            "Z": "A04780/0Z"
          },
          {
            "number_support": 7,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          },
          {
            "number_support": 8,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          },
          {
            "number_support": 9,
            "1": "A01480/01",
            "Z": "A04880/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A033-80/01",
            "3": "A025-80/03"
          },
          {
            "number_support": 3,
            "1": "A033-80/01",
            "3": "A024-80/03"
          },
          {
            "number_support": 4,
            "1": "A033-80/01"
          }
        ]
      }
    ]
  },
  {
    "models": ["5660"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "A": "A00180/0A",
            "Z": "A04180/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["5662"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "A": "A00180/0A",
            "Z": "A04180/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["5664"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "A": "A00180/0A",
            "Z": "A04180/0Z"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["5770"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A00480/01",
            "Z": "A04480/0Z",
            "B": "A00780/0B"
          },
          {
            "number_support": 3,
            "1": "A00480/01",
            "Z": "A04480/0Z",
            "B": "A00780/0B"
          },
          {
            "number_support": 4,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 5,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 6,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A019-80/01",
            "2": "A038-80/02",
            "7": "A039-80/07"
          },
          {
            "number_support": 3,
            "1": "A019-80/01",
            "2": "A038-80/02",
            "7": "A039-80/07"
          },
          {
            "number_support": 4,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["5772"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A00480/01",
            "Z": "A04480/0Z",
            "B": "A00780/0B"
          },
          {
            "number_support": 3,
            "1": "A00480/01",
            "Z": "A04480/0Z",
            "B": "A00780/0B"
          },
          {
            "number_support": 4,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 5,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 6,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A019-80/01",
            "2": "A038-80/02",
            "7": "A039-80/07"
          },
          {
            "number_support": 3,
            "1": "A019-80/01",
            "2": "A038-80/02",
            "7": "A039-80/07"
          },
          {
            "number_support": 4,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["5774"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "1": "A00480/01",
            "Z": "A04480/0Z",
            "B": "A00780/0B"
          },
          {
            "number_support": 3,
            "1": "A00480/01",
            "Z": "A04480/0Z",
            "B": "A00780/0B"
          },
          {
            "number_support": 4,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 5,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          },
          {
            "number_support": 6,
            "Z": "A04180/0Z",
            "A": "A00180/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "1": "A019-80/01",
            "2": "A038-80/02",
            "7": "A039-80/07"
          },
          {
            "number_support": 3,
            "1": "A019-80/01",
            "2": "A038-80/02",
            "7": "A039-80/07"
          },
          {
            "number_support": 4,
            "2": "A038-80/02",
            "7": "A029-80/07"
          }
        ]
      }
    ]
  },
  {
    "models": ["5935"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          },
          {
            "number_support": 3,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A034-80/02"
          }
        ]
      }
    ]
  },
  {
    "models": ["6160"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          },
          {
            "number_support": 3,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A034-80/02"
          }
        ]
      }
    ]
  },
  {
    "models": ["6165"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          },
          {
            "number_support": 3,
            "Z": "A04280/0Z",
            "A": "A00280/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": [
          {
            "number_support": 2,
            "2": "A034-80/02"
          }
        ]
      }
    ]
  },
  {
    "models": ["7450"],
    "catalog": [
      {
        "name": "row",
        "accessories": []
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  },
  {
    "models": ["7455"],
    "catalog": [
      {
        "name": "row",
        "accessories": []
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  },
  {
    "models": ["7460"],
    "catalog": [
      {
        "name": "row",
        "accessories": []
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  },
  {
    "models": ["7470"],
    "catalog": [
      {
        "name": "row",
        "accessories": []
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  },
  {
    "models": ["7475"],
    "catalog": [
      {
        "name": "row",
        "accessories": []
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  },
  {
    "models": ["3235"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A040780/0Z",
            "A": "A040680/0A"
          },
          {
            "number_support": 3,
            "Z": "A040780/0Z",
            "A": "A040680/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  },
  {
    "models": ["5730"],
    "catalog": [
      {
        "name": "row",
        "accessories": [
          {
            "number_support": 2,
            "Z": "A50780/0Z",
            "A": "A50680/0A"
          },
          {
            "number_support": 3,
            "Z": "A50780/0Z",
            "A": "A50680/0A"
          }
        ]
      },
      {
        "name": "usa",
        "accessories": []
      }
    ]
  }
]

interface ElectricalAccesories {
  models: Array<string>
  catalog: Array<{
    name: "row" | "usa"
    accessories: Array<Accessory>
  }>
}

interface Accessory {
  number_support: number
  [K: string]: any
}

interface ElectricalGroup {
  elements: Array<Light>,
  lightsAssigned: number,
  accessory: Accessory
}

export const assignLightsByAccessoryCapacity = (group: Group, catalog): Array<ElectricalGroup> | null => {
  const lights = group.getLights()
  const numOfLights = lights.length
  const model = lights[0].element.getModel()
  const control = group.getAttributeModifier("control")

  const accessories = findElectricalAccessories(model, control, catalog) // [{...acc}, {...acc}]
  if (!accessories) return null

  const accessoriesCombination = getBestAccessoriesCombination(numOfLights, accessories) // bestcombination [3, 3] 
  const lightsPerAccessory = calculateLightsPerAccessory(lights, accessoriesCombination)

  return parseToElectricalGroup(lightsPerAccessory, accessories, control)

}

const findElectricalAccessories = (model: string, control: string, catalog: string) => {
  const modelAccessoriesData = ElectricalAccessories.find(accessoriesData => accessoriesData.models.includes(model))
  if (!modelAccessoriesData) return null
  const catalogData = modelAccessoriesData.catalog
  if (!catalogData) return null
  const accessoryData = catalogData.find(accessoriesByCatalog => accessoriesByCatalog.name === catalog)
  if (!accessoryData) return null
  const accessoriesFilteredByControl = accessoryData.accessories.filter(accessory => accessory.hasOwnProperty(control))
  if (!accessoriesFilteredByControl.length) return null
  return accessoriesFilteredByControl
}

const findMaxCapacityAccessory = (accessories) => {
  let maxCapacityAccessory = accessories[0];
  for (const accessory of accessories) {
    if (accessory.number_support > maxCapacityAccessory.number_support) {
      maxCapacityAccessory = accessory;
    }
  }
  return maxCapacityAccessory.number_support;
}

const getMinNumberAccessories = (numOfLights, maxCapacityAccessory) => {
  let neededGroups = 1
  while (numOfLights > maxCapacityAccessory * neededGroups) {
    neededGroups++
  }
  return neededGroups
}

export const getBestAccessoriesCombination = (numOfLights, accessories) => {
  const maxCapacityAccessory = findMaxCapacityAccessory(accessories)
  const accessoriesNeeded = getMinNumberAccessories(numOfLights, maxCapacityAccessory)
  const averageLightsPerAccessory = Math.floor(numOfLights / accessoriesNeeded)
  const remainingLights = numOfLights % accessoriesNeeded
  const possibleAccessoryCapacities = accessories.map(accessory => accessory.number_support).sort((a, b) => a - b)
  const lightDistribution = new Array(accessoriesNeeded).fill(averageLightsPerAccessory)

  for (let i = 0; i < remainingLights; i++) {
    lightDistribution[i]++
  }

  let lightsProfit = 0 // How many more lights we could add given the distributed accesories
  const bestCombination = lightDistribution.map(lightsInDistribution => {
    const accessoryForCombination = possibleAccessoryCapacities.find(possibleAccesory => possibleAccesory >= lightsInDistribution - lightsProfit)
    lightsProfit = lightsProfit + accessoryForCombination - lightsInDistribution
    return accessoryForCombination
  })

  return bestCombination
}

const calculateLightsPerAccessory = (lights, accessoriesCombination) => {
  let numOfLightsToAssign = lights.length
  let lightsToAssign = [...lights.map((light, i) => ({ ...light, i }))]

  const biggestNumber = Math.max(...accessoriesCombination);
  // pasar de: [9, 9, 6, 4] => [9, 9] [6, 4]
  const notBiggestNumberArr = accessoriesCombination.filter(num => num !== biggestNumber)
  const biggestArr = accessoriesCombination.filter(num => num === biggestNumber)

  const parsedNotBiggestArr: any = []
  if (notBiggestNumberArr.length) {
    notBiggestNumberArr.forEach(item => {
      parsedNotBiggestArr.push({ number_support: item, assigned: item, elements: lightsToAssign.splice(0, item) })
      numOfLightsToAssign -= item
    })
  }

  const parsedBiggestArr = biggestArr.map(item => ({ number_support: item, assigned: 0, elements: [] }))
  do {
    for (let i = 0; i < parsedBiggestArr.length; i++) {
      if (!numOfLightsToAssign) break
      parsedBiggestArr[i].assigned++
      numOfLightsToAssign--
    }
  } while (numOfLightsToAssign > 0)

  const populatedBiggestArr = parsedBiggestArr.map(item => ({ ...item, elements: lightsToAssign.splice(0, item.assigned) }))
  const result = parsedNotBiggestArr.concat(populatedBiggestArr);
  return result
}

const parseToElectricalGroup = (lightsPerAccessory, accessories, control) => {

  const parsedElectricalGroup = lightsPerAccessory.map(item => {
    const accessory = accessories.find(acc => acc.number_support === item.number_support)
    const parsedAccessory = {
      accessoryCode: accessory[control]
    }
    return ({
      elements: item.elements,
      lightsAssigned: item.assigned,
      accessory: parsedAccessory
    })
  })

  return parsedElectricalGroup
}